import React, {useState} from "react";
import {Row, Col, Grid, Button} from "antd";
import moment from "moment";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import Filters from "./filters/Filters";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";
import UploadPoolShiftButton from "./uploadPoolShiftButton/UploadPoolShiftButton";
import CopyForecastButton from "./copyForecastButton/CopyForecastButton";
import {DownloadOutlined} from "@ant-design/icons";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {b64DecodeToUrl} from "../../../utils/helpers";

const {useBreakpoint} = Grid;

const Pools = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingExcelData, setLoadingExcelData] = useState(false);
    const [filters, setFilters] = useState({
        city: "all",
        integrationType: "all",
        status: "all",
        searchText: "",
        managerCompany: "all"
    });

    const [loading, pools] = useFetch({
        fetchFn: stores.poolStore.getPoolList.bind(null, {
            limit: 10,
            page: currentPage,
            city: filters.city,
            integrationType: filters.integrationType,
            status: filters.status,
            searchText: filters.searchText,
            managerCompany: filters.managerCompany
        }),
        dependencies: [filters, currentPage]
    });
    const [poolOptionsLoading, poolOptions] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolStore.getPoolList.bind(null, {
            limit: 1000,
            page: 1,
            city: "all",
            integrationType: "all",
            status: "all"
        }),
        dependencies: [],
        initialCall: true
    });
    const exportPoolExcelFile = async () => {
        setLoadingExcelData(true);
        try {
            const response = await stores.poolStore.exportPoolExcelFile({
                city: filters.city,
                integrationType: filters.integrationType,
                status: filters.status,
                searchText: filters.searchText,
                managerCompany: filters.managerCompany
            });
            const base64Data = response?.data;
            const blobUrl = await b64DecodeToUrl(base64Data);
            const link = document.createElement("a");
            link.href = blobUrl;
            const filename = moment().format("YYYY-MM-DD_HH-mm-ss") + "_pool_export.xlsx";
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.log("error", error);
        } finally {
            setLoadingExcelData(false);
        }
    };

    const screens = useBreakpoint();
    const isMobile = !screens.md;
    return (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            {isMobile ? (
                <Row justify="start" align="middle">
                    <Col xs={24}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 8,
                                marginTop: 8
                            }}
                        >
                            {stores.meStore.checkPermission("pools.excelActions") && (
                                <Button
                                    type="primary"
                                    data-testid="exportWithExcelButton"
                                    onClick={async () => {
                                        exportPoolExcelFile();
                                    }}
                                    loading={loadingExcelData}
                                    icon={<DownloadOutlined />}
                                    style={{marginBottom: "8px"}}
                                >
                                    Excel Çıktısı İndir
                                </Button>
                            )}
                            {stores.meStore.checkRole("showPoolsPageActionButtons") && (
                                <>
                                    {!stores.meStore.checkRole("isAgency") && (
                                        <CopyForecastButton
                                            poolOptions={poolOptions}
                                            poolOptionsLoading={poolOptionsLoading}
                                        />
                                    )}
                                    {stores.meStore.checkPermission("pools.excelActions") && (
                                        <UploadPoolShiftButton />
                                    )}
                                    {!stores.meStore.checkRole("isAgency") && <ActionButtons />}
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            ) : (
                <Row justify="space-between" align="middle">
                    <Col>
                        <Row justify="start" align="middle" gutter={[8, 0]}>
                            <>
                                {stores.meStore.checkPermission("pools.excelActions") && (
                                    <CustomButton
                                        type="primary"
                                        data-testid="exportWithExcelButton"
                                        onClick={async () => {
                                            exportPoolExcelFile();
                                        }}
                                        loading={loadingExcelData}
                                        icon={<DownloadOutlined />}
                                        style={{marginBottom: 16, marginTop: -8, marginLeft: 4}}
                                    >
                                        Excel Çıktısı İndir
                                    </CustomButton>
                                )}
                            </>
                        </Row>
                    </Col>
                    <Col>
                        <Row justify="end" align="middle" gutter={[8, 0]}>
                            {stores.meStore.checkRole("showPoolsPageActionButtons") && (
                                <div style={{display: "flex", gap: "8px"}}>
                                    {!stores.meStore.checkRole("isAgency") && (
                                        <CopyForecastButton
                                            poolOptions={poolOptions}
                                            poolOptionsLoading={poolOptionsLoading}
                                        />
                                    )}
                                    {stores.meStore.checkPermission("pools.excelActions") && (
                                        <UploadPoolShiftButton />
                                    )}
                                    {!stores.meStore.checkRole("isAgency") && <ActionButtons />}
                                </div>
                            )}
                        </Row>
                    </Col>
                </Row>
            )}
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={pools?.data || []}
                    dataCount={pools?.pagination?.totalItems || 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </Row>
        </div>
    );
};

export default Pools;
